import { render, staticRenderFns } from "./CrisisResponseBanner.vue?vue&type=template&id=6338a4de&scoped=true&"
import script from "./CrisisResponseBanner.vue?vue&type=script&lang=js&"
export * from "./CrisisResponseBanner.vue?vue&type=script&lang=js&"
import style0 from "./CrisisResponseBanner.vue?vue&type=style&index=0&id=6338a4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6338a4de",
  null
  
)

/* custom blocks */
import block0 from "./CrisisResponseBanner.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports